module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First and foremost, I must thank my wife, Stefanie. She has always been my biggest supporter and number-one fan, and her belief in me has kept me going. We are empty nesters, going on a few years now, and my work on this book and other projects has made the adjustment much harder than it needed to be. But I have big plans to make it all right!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I also have to give a shout-out to my editor, Kate Jenkins, copy editor Rick Delaney and all the good folks at The History Press. I cannot thank them enough for taking a chance on me and this book. I am truly grateful for the opportunity.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7fa5ca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 69
// module chunks = 0